
(() => {
  if (window.cotigoLimitedSale) return;
  window.cotigoLimitedSale = true;
  let clock = null;
  let syncing = false;
  const pad = value => String(value).padStart(2, '0');
  const remaining = (ms, compact = false) => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const days = Math.floor(total / 86400);
    if (compact) return `${days}d ${pad(Math.floor(total % 86400 / 3600))}:${pad(Math.floor(total % 3600 / 60))}:${pad(total % 60)}`;
    return `${pad(days)} ${days === 1 ? 'día' : 'días'} · ${pad(Math.floor(total % 86400 / 3600))} h · ${pad(Math.floor(total % 3600 / 60))} min · ${pad(total % 60)} s`;
  };
  const activeAt = (root, now) => {
    const end = Number(root?.dataset.saleEnd) * 1000;
    const freshUntil = Number(root?.dataset.saleValidUntil || 0) * 1000;
    return now !== null && Number.isFinite(end) && now < end && (!freshUntil || now < freshUntil);
  };
  const render = () => {
    const now = clock ? clock() : null;
    for (const root of document.querySelectorAll('[data-cotigo-sale]')) {
      const end = Number(root.dataset.saleEnd) * 1000;
      const active = activeAt(root, now);
      for (const compare of root.querySelectorAll('.compare-at-price')) compare.hidden = !active;
      const amount = root.querySelector('.price bdi');
      const display = active ? root.dataset.salePrice : root.dataset.saleRegular;
      if (amount && amount.textContent !== display) amount.textContent = display;
      root.dataset.saleExpired = active ? '' : 'true';
    }
    for (const header of document.querySelectorAll('[data-sale-header]')) {
      const priceRoot = header.closest('.product-details')?.querySelector('product-price [ref="priceContainer"]');
      const end = priceRoot?.matches('[data-cotigo-sale]') ? Number(priceRoot.dataset.saleEnd) * 1000 : NaN;
      const active = !header.hasAttribute('data-sale-header-disabled') && activeAt(priceRoot, now);
      header.hidden = !active;
      if (active) {
        const timer = header.querySelector('[data-sale-remaining]');
        const compact = window.matchMedia?.('(max-width: 1100px)')?.matches || false;
        timer.textContent = remaining(end - now, compact);
        timer.setAttribute('role', 'timer');
        timer.setAttribute('aria-label', 'Tiempo restante: ' + remaining(end - now).replaceAll(' · ', ', ').replace(' h', ' horas').replace(' min', ' minutos').replace(' s', ' segundos'));
      }
    }
  };
  const sync = async () => {
    if (syncing || !document.querySelector('[data-sale-sync-variant]')) return;
    syncing = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js?_cotigo_sale_clock=${Date.now()}`, {cache: 'no-store', credentials: 'same-origin'});
      const epoch = Date.parse(response.headers.get('date'));
      response.body?.cancel().catch(() => {});
      if (!response.ok || !Number.isFinite(epoch)) throw new Error('Clock unavailable');
      const received = performance.now();
      clock = () => epoch + performance.now() - received;
    } catch (_) {
      // Keep the native checkout authoritative; never reset or extend the deadline.
    } finally { syncing = false; render(); }
  };
  let refreshingPrice = false;
  const refreshPrice = async () => {
    const root = document.querySelector('.product-details product-price [data-sale-sync-variant]');
    const section = root?.closest('[id^="shopify-section-"]');
    if (!root || !section || refreshingPrice || document.hidden) return;
    refreshingPrice = true;
    const variant = root.dataset.saleSyncVariant;
    try {
      const url = new URL(location.href);
      url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
      url.searchParams.set('variant', variant);
      url.searchParams.set('_cotigo_sale', Date.now());
      const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin'});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('.product-details product-price [data-sale-sync-variant]');
      const current = document.querySelector('.product-details product-price [data-sale-sync-variant]');
      if (next?.dataset.saleSyncVariant === variant && current?.dataset.saleSyncVariant === variant) {
        current.replaceWith(next);
        render();
      }
    } catch (_) {
      // Expiry/freshness guards keep stale offers from displaying after a failed refresh.
    } finally { refreshingPrice = false; }
  };
  new MutationObserver(changes => {
    if (changes.some(change => [...change.addedNodes].some(node => node instanceof Element && (node.matches('[data-cotigo-sale], [ref="priceContainer"], [data-sale-header]') || node.querySelector('[data-cotigo-sale], [ref="priceContainer"], [data-sale-header]'))))) {
      render();
      if (!clock) sync();
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { sync(); refreshPrice(); } });
  setInterval(render, 1000);
  setInterval(() => { if (!document.hidden) { sync(); refreshPrice(); } }, 60000);
  render(); sync();
})();
